import React from 'react'
import styled from 'styled-components'
import { Colors } from 'advenio-components'
import PropTypes from 'prop-types'

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 16px;
  padding: 16px;
  background: ${Colors.gray200};
  border: 1px solid ${Colors.gray300};
  border-radius: 4px;
`
const CardLogo = styled.img`
  height: 35px;
  margin: 0 8px;
  border-radius: 4px;
`
const CardInfo = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 16px;
  opacity: .7;
  color: ${Colors.gray800};
  font-size: 12px;
  font-weight: bold;
`
const CardData = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 4px;
`
const Digits = styled.div`
  margin: 0px 8px 0 0px;
`
const Date = styled.div`
  margin: 0px 8px;
`
const ParentName = styled.span`
  color: ${Colors.blue500};
  font-size: 16px;
`
const CardsLogo = {
  MAST: '/assets/mastercard.svg',
  AMEX: '/assets/Amex.svg',
  VISA: '/assets/Visa.svg',
}

const CreditCardPreview = ({ card, parentName }) => (
  <Container>
    <CardLogo src={CardsLogo[card.card_brand]} />
    <CardInfo>
      <ParentName>{parentName}</ParentName>
      <CardData>
        <Digits>****{card.last_four}</Digits>
        <Date>{card.exp_month || '00'}/{card.exp_year}</Date>
      </CardData>
    </CardInfo>
  </Container>
)

CreditCardPreview.propTypes = {
  /** The credit card to be displayed */
  card: PropTypes.object,
  /** The parent who owns the given credit card */
  parentName: PropTypes.string.isRequired,
}

export default CreditCardPreview



// WEBPACK FOOTER //
// ./src/Components/CreditCardPreview.jsx